/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "feedbackAPI",
            "endpoint": "https://61ds9vbug0.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ],
    "aws_content_delivery_bucket": "voicecardswebsite-20241216104656-hostingbucket-main",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1lqum4rb4ar3r.cloudfront.net"
};


export default awsmobile;
